// Header.js
import React from "react";
import { View } from "react-native";
import LogoWithTitle from "components/assets/vetmanaged_logo_la_with_title_white";
import MainMenu from "components/Partials/MainMenu";

const Header = ({isLoggedIn}) => {
  const _theme = window.main.theme;

  const styles = {

    headerOuter: {
        alignItems: "center",
        alignSelf: "stretch",
        backgroundColor: _theme.colors.mode[!!isLoggedIn?"backgroundColor":"containerBackgroundColor3"],
        background: (!!isLoggedIn?"linear-gradient(to bottom, #346a0b 20%, #1f3e08 100%)":_theme.colors.mode.containerBackgroundColor3),
        // background: "linear-gradient(to bottom, #2b540b 20%, #1f3e08 100%)",
        // borderBottomColor: _theme.colors.accent,
        // borderBottomWidth: 2,
        cursor: "auto",
        flexDirection: "row",
        flexGrow: 1,
        height: 60,
        maxHeight: 60,  // /!\ Fixes weight bug on Adroid when keyboard is showing/hidden.
        justifyContent: "center",
        pointerEvents: "auto",

        zIndex: 9996,
    },

    header: {
        alignSelf: "stretch",
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        height: 60,
        justifyContent: "center",
        maxWidth: 1400,
        position: "relative",
    },
    headerLogoWrapper: {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
    },
    headerLogo: {
        height: 20,
        width: 20,
        marginRight: 5,
    },
    text: {
        color: _theme.colors.opposite_mode.textColor,
        // color: window.main.theme.colors.emph,
        fontSize: 20,
        textAlign: "center",
        marginLeft: 10,
    },
  };

  return (
    <View style={styles.headerOuter}>
      {!!isLoggedIn &&
        <View style={styles.header}>
          <View style={{...styles.headerLogoWrapper}}>
            {/* <View id="glowBg" style={{position:"absolute",top:"50%",left:"50%",marginLeft:-80,marginTop:0,width:1,height:1,backgroundColor:"#ffffff80",borderRadius:"50%",boxShadow:"0 0 25px 13px #ffffff",zIndex:1}}></View> */}
            <LogoWithTitle height={60} style={{zIndex:2}} />
          </View>
          <View style={{position:"absolute",top:8,right:0,borderTopLeftRadius:14,borderBottomLeftRadius:14,paddingLeft:10,paddingBottom:10}}>
              <MainMenu />
          </View>
        </View>
      }
    </View>
  );
};

export default Header;
